import {
  mdiVectorCircle,
  mdiLayers,
  mdiFormatListBulleted,
  mdiFileImage,
  mdiNoteText,
  mdiAttachment,
  mdiPlaylistCheck,
  mdiArchiveOutline,
  mdiNaturePeople
} from '@mdi/js'

export default {
  default: [
    {
      title: 'Projects',
      icon: mdiLayers,
      to: 'field-project',
    },
    {
      title: 'Form Templates',
      icon: mdiVectorCircle,
      to: 'field-form-template-list',
    },
    {
      title: 'My Tasks',
      icon: mdiPlaylistCheck,
      to: 'my-field-tasks',
    },
    {
      title: 'Archives',
      icon: mdiArchiveOutline,
      to: 'field-archives',
    },
  ],
  more: [
    {
      title: 'Projects',
      icon: mdiLayers,
      to: 'field-project',
    },
    {
      title: 'Plans',
      icon: mdiLayers,
      to: 'field-plans',
    },
    // {
    //   title: 'Specifications',
    //   icon: mdiVectorCircle,
    //   to: 'field-specifications'
    // },
    {
      title: 'Tasks',
      icon: mdiFormatListBulleted,
      to: 'field-tasks',
    },
    {
      title: 'Photos',
      icon: mdiFileImage,
      to: 'field-photos',
    },
    {
      title: 'Forms',
      icon: mdiNoteText,
      to: 'field-form-folders',
    },
    {
      title: 'People',
      icon: mdiNaturePeople,
      to: 'field-people',
    },
    {
      title: 'Files',
      icon: mdiAttachment,
      to: 'field-files',
    },
  ],
}
